import React, { useState, useEffect, useRef } from "react";
import AppContext from "../Context/Context";
import axios from "axios";
import { PostCodeAutofill } from "../Model/PostCodeAutofill";
import { Location } from "../Model/Location";
type Props = {
  locationCode: string;
  setSelectedLocation: Function;
  setLocationDetails: Function;
};

export default function LocationsSuggestions(props: Props) {
  const [locationSuggestions, setLocationSuggestions] = useState<any>([]);
  const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);

  const [takeAction, setTakeAction] = useState(true);

  const locationRef = useRef<any>(null);
  useEffect(() => {
    // Function to handle outside clicks
    const handleClickOutside = (event: any) => {
      if (locationRef.current && !locationRef.current.contains(event.target)) {
        setShowLocationSuggestions(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (props.locationCode !== "" && takeAction) {
      setTakeAction(true);
      getLocation(props.locationCode);
    }
  }, [props.locationCode]);

  /*
  getaddress.io was shut down.. 5th Feb, 2026
  function getLocation(code: string) {
    props.setSelectedLocation(code);
    axios
      .get(
        "https://api.getaddress.io/autocomplete/" +
          code +
          "?expand=true&all=true&api-key=" +
          AppContext.AddressApiKey +
          "",
      )
      .then((response) => {
        let data = response.data.suggestions;
        var postCodeSuggestions = [];
        for (let i = 0; i < data.length; i++) {
          let obj = new PostCodeAutofill(
            data[i].address,
            data[i].id,
            data[i].url,
          );
          postCodeSuggestions.push(obj);
        }
        setLocationSuggestions(postCodeSuggestions);
        setShowLocationSuggestions(true);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getAddressById(id: string) {
    axios
      .get(
        "https://api.getaddress.io/get/" +
          id +
          "?expand=true&api-key=" +
          AppContext.AddressApiKey +
          "",
      )
      .then((response) => {
        let data = response.data;
        let postCode = data.postcode;
        let street =
          data.line_1 +
          " " +
          data.line_2 +
          " " +
          data.line_3 +
          " " +
          data.line_4;
        let city = data.town_or_city;
        let adreesObj = new Location(postCode, street, city);
        props.setLocationDetails(adreesObj);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  */

  
  function getLocation(code: string) {
    props.setSelectedLocation(code);
    axios
      .get(
        "https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses?query=" +
          code +
          //"&bias_ip=true&context=FRA"+
          "&api_key=" +
          AppContext.IdealPostcodeApiKey +
          "",
      )
      .then((response) => {
        let data = response.data.result.hits;
        var postCodeSuggestions = [];
        for (let i = 0; i < data.length; i++) {
          let obj = new PostCodeAutofill(
            data[i].suggestion,
            data[i].id,
            data[i].urls.udprn,
          );
          postCodeSuggestions.push(obj);
        }
        setLocationSuggestions(postCodeSuggestions);
        setShowLocationSuggestions(true);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getAddressById(id: string) {
    axios
      .get(
        "https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses/"+id+"/gbr?api_key=" + AppContext.IdealPostcodeApiKey+
          "",
      )
      .then((response) => {
        let data = response.data.result;
        let postCode = data.postcode;
        let street =
          data.line_1 +
          " " +
          data.line_2 +
          " " +
          data.line_3
        let city = data.post_town;
        let adreesObj = new Location(postCode, street, city);
        props.setLocationDetails(adreesObj);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function assignAutofillValues(address: string) {
    setTakeAction(false);
    props.setSelectedLocation(address);
    setShowLocationSuggestions(false);

    setTimeout(() => {
      setTakeAction(true);
    }, 1000);
  }

  return (
    <>
      {showLocationSuggestions && props.locationCode !== "" && (
        <div className="loc-drop" ref={locationRef}>
          <div className="loc-drop-inn custom-scroll">
            {locationSuggestions &&
              locationSuggestions.map((item: PostCodeAutofill) => (
                <a
                  key={item.ID}
                  onClick={() => {
                    assignAutofillValues(item.Address);
                    getAddressById(item.ID);
                  }}
                >
                  <span> {item.Address}</span>
                </a>
              ))}
          </div>
        </div>
      )}
    </>
  );
}
